// extracted by mini-css-extract-plugin
module.exports = {"sellerGrid":"SellerGrid_sellerGrid__XauAW","swiperContainer":"SellerGrid_swiperContainer__WzCI5"};